import { useCurrentApplicationUuid } from "./useCurrentApplicationUuid";

function useLendingApplicationID(): string {
  return useCurrentApplicationUuid();
}

export { useLendingApplicationID };
